if (typeof AFRAME === 'undefined') {
  throw new Error('Component attempted to register before AFRAME was available.');
}

AFRAME.registerComponent('lookatlabel', {
  init: function () {
    this.vector = new THREE.Vector3();
  },

  tick: function (t) {
    var self = this;
    var target = self.el.sceneEl.camera;
    var object3D = self.el.object3D;

    // make sure camera is set
    if (target) { 
         target.updateMatrixWorld();
         this.vector.setFromMatrixPosition(target.matrixWorld);
         if (object3D.parent) {
           object3D.parent.updateMatrixWorld();
           object3D.parent.worldToLocal(this.vector);

         }
     //    return object3D.lookAt(this.vector); 
         return object3D.lookAt(new THREE.Vector3(this.vector.x, object3D.position.y, this.vector.z));
    }
  }
});


// WEBPACK FOOTER //
// ./src/aframe/components/lookatlabel.js